<template>
  <div/>
</template>
<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'page-event-tagging',
    props: {
      tagging: {
        required: false,
        type: Object,
        default: undefined
      }
    },
    data() {
      return {
        taggingEventFired: false,
      };
    },
    mounted() {
      this.pageLoadTagging();
    },
    methods: {
      pageLoadTagging() {
        /* istanbul ignore next */
        if (this.tagging !== undefined) {
          this.taggingEventFired = true;
          AnalyticsHandler.pushDataLayer(this.tagging);
        }
      }
    }
  };
</script>
